<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.procedimento"
                    :request-query-string-params="autocompleteQueryStringParams.procedimento"
                    :search-fields="fields.autocompletes.procedimentoSolicitado"
                    :validations="validations.procedimentoSolicitado"
                    :disabled="!cid"
                    label="Procedimento solicitado"
                    placeholder="Digite o código ou nome do procedimento relacionado ao CID principal inserido. Para visualizar todos, clique na lupa ao lado."
                    v-model="model.procedimentoSolicitado"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-button
                            @click="$refs.ModalBuscaProcedimento.open({ cid, registro: 'aih', onlyWithCid: true })"
                            color="primary"
                            :disabled="!cid"
                            title="Buscar procedimentos relacionados"
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>
                    </rkm-input-group-append>
                </rkm-form-input-autocomplete>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-date-picker
                    :max-date="additionals.dataAtual"
                    :validations="validations.dataSolicitacao"
                    label="Data da solicitação"
                    v-model="model.dataSolicitacao"
                />
            </rkm-col>

            <rkm-col cols="5">
                <rkm-form-select
                    :options="form.clinicas"
                    :validations="validations.clinica"
                    label="Clínica"
                    show-default-option
                    text-field="nome"
                    v-model="model.clinicaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.caratersInternacao"
                    :validations="validations.caraterInternacao"
                    label="Caráter de internação"
                    show-default-option
                    text-field="nome"
                    v-model="model.caraterInternacaoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="8">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :search-fields="fields.autocompletes.profissionalSolicitanteAssistente"
                    :validations="validations.profissionalSolicitanteAssistente"
                    label="Nome do profissional solicitante / Assistente"
                    v-model="model.profissionalSolicitanteAssistente"
                    text-field="cidadaoNome"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :disabled="disabledDocumentoNumero"
                    :label="false"
                    :mask="documentoNumeroMask"
                    :readonly="!model.documentoTipoId"
                    :validations="validations.documentoNumero"
                    name="Número do documento"
                    v-model="model.documentoNumero"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text>
                            <rkm-form-radio-group
                                :disabled="!model.profissionalSolicitanteAssistente"
                                :options="form.documentos"
                                text-field="nome"
                                v-model="model.documentoTipoId"
                                value-field="id"
                            />
                        </rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <ModalBuscaProcedimento
            ref="ModalBuscaProcedimento"
            title="Procedimentos compatíveis ao CID principal selecionado"
            @select="model.procedimentoSolicitado = $event"
        />
    </div>
</template>

<script>
import ModalBuscaProcedimento from '@/components/sigtap/procedimento/busca/Modal'

import tipoDocumento from '@/enums/cadastro/documentoTipo'

import { repository, mask, object } from '@/mixins'

export default {
    components: {
        ModalBuscaProcedimento,
    },
    computed: {
        autocompleteQueryStringParams() {

            return {
                procedimento: {
                    registro: 'aih',
                    cid_id: this.getSafely(() => this.cid.id),
                    only_with_cid: true
                }
            }
        },
        fields() {

            return {
                autocompletes: {
                    procedimentoSolicitado: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                    profissionalSolicitanteAssistente: [
                        { key: 'cadastroCidadao.nome', searchable: true },
                    ]
                }
            }
        },
        validations() {

            return {
                procedimentoSolicitado: { required: true },
                dataSolicitacao: { required: true },
                clinica: { required: true },
                caraterInternacao: { required: true },
                profissionalSolicitanteAssistente: { required: true },
                documentoNumero: {
                    required: true,
                    cns: this.model.documentoTipoId === this.enums.tipoDocumento.CNS,
                    cpf: this.model.documentoTipoId === this.enums.tipoDocumento.CPF
                },
            }
        },
        documentoNumeroMask() {

            switch (this.model.documentoTipoId) {

                case this.enums.tipoDocumento.CNS: {

                    return this.mask.cns
                }
                case this.enums.tipoDocumento.CPF: {

                    return this.mask.cpf
                }
                default: {

                    return ''
                }
            }
        },
        disabledDocumentoNumero() {

            if (!this.model.profissionalSolicitanteAssistente) {

                return true
            }

            switch (this.model.documentoTipoId) {

                case this.enums.tipoDocumento.CNS: {

                    return !!this.model.profissionalSolicitanteAssistente.cidadaoCns
                }
                case this.enums.tipoDocumento.CPF: {

                    return !!this.model.profissionalSolicitanteAssistente.cidadaoCpf
                }
                default: {

                    return false
                }
            }
        }
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
    },
    data: () => ({
        enums: { tipoDocumento }
    }),
    mixins: [repository, mask, object],
    props: {
        additionals: { type: Object, required: true },
        cid: { type: Object },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        cid(cid) {

            if (!cid) {

                this.model.procedimentoSolicitado = null
            }
        },
        'model.profissionalSolicitanteAssistente'(profissional) {

            if (!profissional) {

                this.model.documentoTipoId = null
            }
        },
        'model.documentoTipoId'(id) {

            this.$nextTick().then(() => {

                switch (id) {

                    case this.enums.tipoDocumento.CNS: {

                        this.model.documentoNumero = this.model.profissionalSolicitanteAssistente.cidadaoCns

                        break
                    }
                    case this.enums.tipoDocumento.CPF: {

                        this.model.documentoNumero = this.model.profissionalSolicitanteAssistente.cidadaoCpf

                        break
                    }
                    default: {

                        this.model.documentoNumero = ''

                        break
                    }
                }
            })
        }
    }
}
</script>